import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { BaseUrl } from "../../../redux/config";
import axios from "axios";
import { Modal, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useHistory, withRouter } from "react-router-dom";
import { Texterror } from "../../../constants/Texterror";
import { getSession } from "../../../redux/actions/authActions";
import { bankforms } from "../../../constants/Validation";
import { useDispatch, useSelector } from "react-redux";
import { refTypesList } from "../../../redux/actions/dbactions/refactions";
import { getProfile } from "../../../redux/actions/dbactions/profileActions";
import { Header } from "../../Header";
import FacilitiesIcon from "../../../../assets/FacilitiesIcon";
import { toast } from "react-toastify";

const BankDetails = () => {
  const { user_profile_id, role_id, email } = getSession();
  const dispatch = useDispatch();
  const history = useHistory();
  const { refsdata } = useSelector((state) => state.refstypes);
  const { profile } = useSelector((state) => state.profileReducer);
  const [showModal, setShowModal] = useState(false);
  const handleCancel = () => {
    history.goBack();
  };
  const [validEmail, setValidEmail] = useState(false);
  useEffect(() => {
    dispatch(refTypesList());
  }, [dispatch]);

  useEffect(() => {
    if (profile.usr?.rec[0]?.user_profile_id) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  }, [profile]);

  const [url, setUrl] = useState(null);
  const handleCloseModal = () => setShowModal(false);
  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);
  // var selectedCntry = "ZWE";
  // var selectedBank = "";
  const handleSubmit = async (values, { setSubmitting }) => {
    const { token } = getSession();
    values.user_profile_id = profile.usr?.rec[0]?.user_profile_id
      ? profile.usr?.rec[0]?.user_profile_id
      : user_profile_id;
    try {
      let response = await axios.post(`${BaseUrl}bank/`, values, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (
        response.data.usr.stripe_url &&
        response.data.usr.stripe_url.length > 0
      ) {
        setUrl(response.data.usr.stripe_url);
      } else {
        toast.success(response.data.usr.message);
        history.goBack();
      }
      setSubmitting(false);
      return response.data;
    } catch (err) {
      toast.error(
        `There was a problem: ${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
      setSubmitting(false);
    }
  };
  const handleGetProfile = (e) => {
    dispatch(getProfile(e.target.value));
    setShowModal(true); // Show modal on blur
  };
  const countryname = refsdata.usr?.iso_cntry_stripe || [];
  // const localBanks = refsdata.usr?.service_payout_local_banks || [];

  const handleCountryChange = (event, setFieldValue) => {
    const selectedCountryId = event.target.value;
    setFieldValue("svc_bank_cntry_id", selectedCountryId);
    // const selectedItem = countryname.find(
    //   (item) => item.iso_cntry_id === selectedCountryId
    // );
    // selectedCntry = selectedItem.iso_cntry_cde;
  };

  // const handleBankChange = (event, setFieldValue) => {
  //   const selectedBankId =d event.target.value;
  //   setFieldValue("svc_bank_cntry_id", selectedBankId);
  //   const selectedItem = localBanks.find(
  //     (item) => item.svcplb_id === selectedBankId
  //   );
  //   selectedBank = selectedItem.svcplb_bank_name;
  // };

  return (
    <div>
      <Header
        pageTitle="Bank Details > Add New Bank"
        icon={<FacilitiesIcon />}
      />

      <div className="profile">
        <div className="card_white_box">
          <h5 className="globale-title !px-0">
            <span>Bank Details</span>
          </h5>
          <Formik
            initialValues={{
              user_profile_id: user_profile_id,
              svc_bank_id: null,
              svc_bank_bank_name: "",
              svc_bank_routing_nbr: null,
              svc_bank_swiftcode: null,
              svc_bank_iban_code: "",
              svc_bank_account: "",
              svc_bank_active_yn: "Y",
              svc_bank_cntry_id:
                countryname.length > 0 ? countryname[0].iso_cntry_id : "",
              sys_user_id: user_profile_id,
              role_id: role_id,
              bank_acct_holder_name: "",
              bank_acct_email: role_id < 4 ? "" : email,
            }}
            validationSchema={bankforms}
            onSubmit={handleSubmit}
          >
            {({
              touched,
              errors,
              values,
              handleSubmit,
              setFieldValue,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Account Holder</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.bank_acct_holder_name &&
                          errors.bank_acct_holder_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name="bank_acct_holder_name"
                        type="text"
                        placeholder="Account holder name"
                        value={values.bank_acct_holder_name}
                        onChange={(e) =>
                          setFieldValue(
                            "bank_acct_holder_name",
                            e.target.value.toUpperCase()
                          )
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    {role_id < 4 && (
                      <div className="mb-3">
                        <Form.Label>
                          Bank owner Email (ID=
                          {profile.usr?.rec[0]?.user_profile_id
                            ? profile.usr?.rec[0]?.user_profile_id
                            : user_profile_id}
                          )
                        </Form.Label>
                        <Field
                          className={`form-control ${
                            touched.bank_acct_email && errors.bank_acct_email
                              ? "is-invalid"
                              : ""
                          }`}
                          name="bank_acct_email"
                          type="text"
                          disabled={role_id === 4}
                          placeholder="Account owner email"
                          value={values.bank_acct_email}
                          onChange={(e) =>
                            setFieldValue(
                              "bank_acct_email",
                              e.target.value.toUpperCase()
                            )
                          }
                          onBlur={handleGetProfile} // Call handleBlur on blur event
                        />
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Bank Country</Form.Label>
                      <>
                        <Form.Select
                          className="form-control"
                          name="svc_bank_cntry_id"
                          aria-label="Default select example"
                          onChange={(e) =>
                            handleCountryChange(e, setFieldValue)
                          }
                          value={values?.svc_bank_cntry_id || ""} // Added null check for values
                        >
                          <option value="">Select Country</option>
                          {countryname &&
                            countryname.map(
                              (
                                item,
                                index // Added null check for countryname
                              ) => (
                                <option key={index} value={item.iso_cntry_id}>
                                  {item.iso_cntry_name}
                                </option>
                              )
                            )}
                        </Form.Select>
                        <ErrorMessage
                          name="svc_bank_cntry_id"
                          component={Texterror}
                        />
                      </>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Bank Name</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.svc_bank_bank_name &&
                          errors.svc_bank_bank_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name="svc_bank_bank_name"
                        type="text"
                        placeholder="Bank Name"
                        value={values.svc_bank_bank_name}
                        onChange={(e) =>
                          setFieldValue(
                            "svc_bank_bank_name",
                            e.target.value.toUpperCase()
                          )
                        }
                      />
                      <ErrorMessage
                        name="svc_bank_bank_name"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>IBAN code</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.svc_bank_iban_code &&
                          errors.svc_bank_iban_code
                            ? "is-invalid"
                            : ""
                        }`}
                        name="svc_bank_iban_code"
                        type="text"
                        placeholder="IBAN Code"
                        value={values.svc_bank_iban_code}
                        onChange={(e) =>
                          setFieldValue(
                            "svc_bank_iban_code",
                            e.target.value.toUpperCase()
                          )
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Account#</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.svc_bank_account && errors.svc_bank_account
                            ? "is-invalid"
                            : ""
                        }`}
                        name="svc_bank_account"
                        type="text"
                        placeholder="Bank Account Number"
                        value={values.svc_bank_account}
                      />
                      <ErrorMessage
                        name="svc_bank_account"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>SWIFT Code</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.svc_bank_swiftcode &&
                          errors.svc_bank_swiftcode
                            ? "is-invalid"
                            : ""
                        }`}
                        name="svc_bank_swiftcode"
                        type="text"
                        placeholder="Swift Code"
                        value={values.svc_bank_swiftcode}
                        onChange={(e) =>
                          setFieldValue(
                            "svc_bank_swiftcode",
                            e.target.value.toUpperCase()
                          )
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Routing#</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.svc_bank_routing_nbr &&
                          errors.svc_bank_routing_nbr
                            ? "is-invalid"
                            : ""
                        }`}
                        name="svc_bank_routing_nbr"
                        type="number"
                        placeholder="Routing Number"
                        value={values.svc_bank_routing_nbr}
                        onChange={(e) =>
                          setFieldValue(
                            "svc_bank_routing_nbr",
                            e.target.value.toUpperCase()
                          )
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mini_edit">
                      <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={!validEmail && role_id < 4}
                      >
                        {isSubmitting ? (
                          <Spinner animation="border" variant="primary" />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>

          {/* Information Modal */}
          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Is this the account owner?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {profile.usr?.rec[0]?.user_profile_id ? (
                <>
                  <p>
                    <b>Email entered:</b> {profile.usr.rec[0].user_email}
                  </p>
                  <p>
                    <b>Owner Name:</b> [{profile.usr.rec[0].user_profile_id}]{" "}
                    {profile.usr.rec[0].user_title_cd}{" "}
                    {profile.usr.rec[0].user_first_name}{" "}
                    {profile.usr.rec[0].user_last_name}
                  </p>
                </>
              ) : (
                <p>EMAIL NOT FOUND! Please enter a valid email</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default withRouter(BankDetails);
